<!--
 * @Author: Victor
 * @Date: 2023-12-27 19:08:08
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-30 17:56:59
 * @Description:
    只負責觸發下注,isSubmiting 為 true 時禁用
    组件名：<ButtonBet 
-->
<template>
    <Button
        @click="onNormalClick"
        v-click-and-rest
        :dismark="disabled || isSubmiting"
        :disabled="disabled || isSubmiting"
        mode="primaryContainedShadow"
        :btnColorMode="btnColorMode"
        class="h-full !rounded-[7px] text-center justify-center text-white w-[50%] sm:w-[30%]"
    >
        <div>
            <span class="expected-label">
                {{ label ? label : t.Bet }}
            </span>
            <!-- ↓ 提示用户预计提现的金额 -->
            <div v-if="isShowCashoutValue"
                class="second-row"
                :class="{
                    [joinStateStore.gameName]: true,
                }"
            >
                <span class="expected-reward-label">
                    {{ expectedRewardLabel }}
                </span>
                <span class="expected-reward">
                    {{ expectedReward ? expectedReward.toFixed(2) : '' }}
                </span>
                <!-- ↓ 在 Mini 版废弃了，唯一显示金额的 blackjack 都不显示币种信息了 -->
                <!-- <span class="">
                    {{ ` ${userStore.oNowCurrency.currencyName.toUpperCase()}` }}
                </span> -->
            </div>
        </div>
    </Button>
</template>

<script lang="ts" setup>
import useTranslation from '~/i18n/useTransLation';
import betHelper from '~/common/js/betHelper';
import { getGameName } from '@/common/js/gameAbout';
import { useJoinStateStore } from '~/stores/cansino/joinState';

const t = useTranslation();
const userStore = useUserStore();
const joinStateStore = useJoinStateStore();

const props = defineProps({
    expectedRewardLabel: {
        type: String,
    },
    expectedReward: {
        type: Number,
        default: 0,
        required: false,
    },
    isSubmiting: {
        type: Boolean,
        required: true,
    },
    betSubmit: {
        type: Function as PropType<() => Promise<void>>,
        required: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    label: {
        type: String,
    },
    btnColorMode: {
        type: String,
    },
});


const isShowCashoutValue = computed(()=>{
    const whiteGamasList = [
        'blackjackGame',
        // ↓ Mini 版中不再显示按钮上的返现金额，在此注释掉它们
        // 'spacediceGame',
        // 'diceGame',
        // 'towerGame',
        // 'stairsGame',
    ];
    const bResult = (
        props.expectedReward > 0
        && whiteGamasList.includes(joinStateStore.gameName)
    );
    return bResult;
});

const emit = defineEmits(['update:isSubmiting']);
const onNormalClick = async () => {
    // A类游戏是一键下注并立即结束的、B类游戏是下注后需要执行选择，再点击【提现】的 
    // 所以，B类游戏在点击此按钮时未必是在执行下注，有可能在试图【提现】
    // 那么，在下注时统一监测余额，0余额要拦截。另一方面在【提现】时无限制，0余额也能执行提现 
    // 要处理的 B类游戏有：towers, stairs （其它 B 类游戏没调用此组件） 
    const executable = (
        // ↓ 特殊游戏，放行，任其下注或提现（0余额也让下注，交给接口拒绝用户的下注）
        ['towerGame', 'stairsGame'].includes(getGameName())
        // ↓ 余额足返回 true ，余额不足返回 false，并弹出提示框（这行一定放下方，以规避执行并弹出消息） 
        || betHelper.betableCheck()
    );
    const canSubmit = (!props.isSubmiting && executable);
    console.log("点击了手工下注/提现按钮；否可向下执行：", canSubmit); 
    if (!canSubmit) return;
    emit('update:isSubmiting', true);
    await props.betSubmit();
    emit('update:isSubmiting', false);
};
</script>

<style lang="scss" scoped>
.second-row{
    font-size: 13px; 
    opacity: 0.85;
    .expected-reward-label{
        display: block;
    }
    &.blackjackGame{
        *{
            display: inline-block;
            margin-left: 3px;
        }
    }
}

</style>
